import { render } from "./matchSuggestions.vue?vue&type=template&id=5c38463a&scoped=true&ts=true"
import script from "./matchSuggestions.vue?vue&type=script&lang=ts"
export * from "./matchSuggestions.vue?vue&type=script&lang=ts"

import "./matchSuggestions.vue?vue&type=style&index=0&id=5c38463a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c38463a"]])

export default __exports__